import { join } from "path";

export const ROOT_ROUTE: string = process.env.PUBLIC_URL;
export const LOGIN_ROUTE: string = "/login";
export const LOGOUT_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/logout"
  : "/logout";
export const FORBIDENT_ROUTE: string = "/403";
export const NOT_FOUND_ROUTE: string = "/404";
export const LANDING_PAGE_ROUTE: string = "/landing-page";

export const TYPOGRAPHY_PAGE_ROUTE: string = ROOT_ROUTE
  ? join(ROOT_ROUTE + "/typography")
  : "/typography";
export const COLOR_PAGE_ROUTE: string = ROOT_ROUTE
  ? join(ROOT_ROUTE + "/color")
  : "/color";
export const SIDE_BAR_PAGE_ROUTE: string = ROOT_ROUTE
  ? join(ROOT_ROUTE + "/side-bar")
  : "/side-bar";

export const THEME_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/theme"
  : "/theme";
export const THEME_MASTER_ROUTE: string = join(THEME_ROUTE, "theme-master");

// Quản lý tài khoản
export const ACCOUNT_MANAGEMENT_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/account-management"
  : "/account-management";

// Tài khoản

export const APP_USER_ROUTE: string = join(
  ACCOUNT_MANAGEMENT_ROUTE,
  "app-user"
);

export const APP_USER_MASTER_ROUTE: string = join(
  APP_USER_ROUTE,
  "app-user-master"
);
export const APP_USER_DETAIL_ROUTE: string = join(
  APP_USER_ROUTE,
  "app-user-detail"
);

export const APP_USER_PERMISSION_ROUTE: string = join(
  APP_USER_ROUTE,
  "app-user-permission"
);

export const APP_USER_PERMISSION_HISTORY_ROUTE: string = join(
  APP_USER_ROUTE,
  "app-user-history"
);
export const APP_USER_PERMISSION_HISTORY_LIST_ROUTE: string = join(
  APP_USER_PERMISSION_HISTORY_ROUTE,
  "app-user-history-list"
);

export const APP_USER_PERMISSION_HISTORY_PREVIEW_ROUTE: string = join(
  APP_USER_PERMISSION_HISTORY_ROUTE,
  "app-user-permission-history-preview"
);

export const APP_USER_PERMISSION_HISTORY_DETAIL_ROUTE: string = join(
  APP_USER_PERMISSION_HISTORY_ROUTE,
  "app-user-history-detail"
);

// Nhóm người dùng
export const APP_USER_GROUPING_ROUTE: string = join(
  ACCOUNT_MANAGEMENT_ROUTE,
  "app-user-grouping"
);

export const APP_USER_GROUPING_MASTER_ROUTE: string = join(
  APP_USER_GROUPING_ROUTE,
  "app-user-grouping-master"
);

export const APP_USER_GROUPING_HISTORY_ROUTE: string = join(
  APP_USER_GROUPING_ROUTE,
  "app-user-grouping-history"
);
export const APP_USER_GROUPING_HISTORY_LIST_ROUTE: string = join(
  APP_USER_GROUPING_HISTORY_ROUTE,
  "app-user-grouping-history-list"
);
export const APP_USER_GROUPING_HISTORY_DETAIL_ROUTE: string = join(
  APP_USER_GROUPING_HISTORY_ROUTE,
  "app-user-grouping-history-detail"
);

// Nhóm người dùng hồ sơ dự án
export const APP_USER_GROUPING_PROJECT_PROFILE_ROUTE: string = join(
  ACCOUNT_MANAGEMENT_ROUTE,
  "project-document-user-grouping"
);
export const APP_USER_GROUPING_PROJECT_PROFILE_MASTER_ROUTE: string = join(
  APP_USER_GROUPING_PROJECT_PROFILE_ROUTE,
  "project-document-user-grouping-master"
);
export const APP_USER_GROUPING_PROJECT_PROFILE_HISTORY_ROUTE: string = join(
  APP_USER_GROUPING_PROJECT_PROFILE_ROUTE,
  "project-document-user-grouping-history"
);
export const APP_USER_GROUPING_PROJECT_PROFILE_HISTORY_LIST_ROUTE: string =
  join(
    APP_USER_GROUPING_PROJECT_PROFILE_HISTORY_ROUTE,
    "project-document-user-grouping-history-list"
  );
export const APP_USER_GROUPING_PROJECT_PROFILE_HISTORY_DETAIL_ROUTE: string =
  join(
    APP_USER_GROUPING_PROJECT_PROFILE_HISTORY_ROUTE,
    "project-document-user-grouping-history-detail"
  );
// Vai trò
export const ROLE_ROUTE: string = join(ACCOUNT_MANAGEMENT_ROUTE, "role");
export const ROLE_MASTER_ROUTE: string = join(ROLE_ROUTE, "role-master");
export const ROLE_DETAIL_ROUTE: string = join(ROLE_ROUTE, "role-detail");
export const ROLE_HISTORY_ROUTE: string = join(ROLE_ROUTE, "role-history");
export const ROLE_HISTORY_LIST_ROUTE: string = join(
  ROLE_HISTORY_ROUTE,
  "role-history-list"
);
export const ROLE_HISTORY_DETAIL_ROUTE: string = join(
  ROLE_HISTORY_ROUTE,
  "role-history-detail"
);

// Vị trí
export const RESPONSIBILITY_ROUTE: string = join(
  ACCOUNT_MANAGEMENT_ROUTE,
  "responsibility"
);
export const RESPONSIBILITY_MASTER_ROUTE: string = join(
  RESPONSIBILITY_ROUTE,
  "responsibility-master"
);
export const RESPONSIBILITY_DETAIL_ROUTE: string = join(
  RESPONSIBILITY_ROUTE,
  "responsibility-detail"
);
export const RESPONSIBILITY_HISTORY_ROUTE: string = join(
  RESPONSIBILITY_ROUTE,
  "responsibility-history"
);
export const RESPONSIBILITY_HISTORY_LIST_ROUTE: string = join(
  RESPONSIBILITY_HISTORY_ROUTE,
  "responsibility-history-list"
);
export const RESPONSIBILITY_HISTORY_DETAIL_ROUTE: string = join(
  RESPONSIBILITY_HISTORY_ROUTE,
  "responsibility-history-detail"
);
// Cây tổ chức
export const ORGANIZATION_ROUTE: string = join(
  ACCOUNT_MANAGEMENT_ROUTE,
  "organization"
);
export const ORGANIZATION_MASTER_ROUTE: string = join(
  ORGANIZATION_ROUTE,
  "organization-master"
);
export const ORGANIZATION_DETAIL_ROUTE: string = join(
  ORGANIZATION_ROUTE,
  "organization-detail"
);
export const APP_LOGGING_API_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/logging-management"
  : "/logging-management";

export const APP_LOGGING_API_MASTER_ROUTE: string = join(
  APP_LOGGING_API_ROUTE,
  "log-integration-api/log-integration-api-master"
);
export const APP_LOGGING_API_DETAIL_ROUTE: string = join(
  APP_LOGGING_API_ROUTE,
  "/log-integration-api/log-integration-api-detail"
);
export const APP_LOGGING_API_PREVIEW_ROUTE: string = join(
  APP_LOGGING_API_ROUTE,
  "log-integration-api-preview"
);

export const DOCUMENT_PERMISSION_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/document/document-permission"
  : "/document/document-permission";
export const DOCUMENT_PERMISSION_MASTER_ROUTE: string = join(
  DOCUMENT_PERMISSION_ROUTE,
  "document-permission-master"
);
export const DOCUMENT_PERMISSION_DETAIL_ROUTE: string = join(
  DOCUMENT_PERMISSION_ROUTE,
  "document-permission-detail"
);
export const DOCUMENT_PERMISSION_HISTORY_ROUTE: string = join(
  DOCUMENT_PERMISSION_ROUTE,
  "document-permission-history"
);
export const DOCUMENT_PERMISSION_HISTORY_LIST_ROUTE: string = join(
  DOCUMENT_PERMISSION_HISTORY_ROUTE,
  "document-permission-history-list"
);
export const DOCUMENT_PERMISSION_HISTORY_DETAIL_ROUTE: string = join(
  DOCUMENT_PERMISSION_HISTORY_ROUTE,
  "document-permission-history-detail"
);
export const USER_NOTIFICATION_ROUTE: string = "/portal/user-notification";

export const DISTRICT_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/district"
  : "/district";
export const DISTRICT_MASTER_ROUTE: string = join(
  DISTRICT_ROUTE,
  "district-master"
);

export const PROVINCE_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/province"
  : "/province";
export const PROVINCE_MASTER_ROUTE: string = join(
  PROVINCE_ROUTE,
  "province-master"
);

export const REGION_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/region"
  : "/region";
export const REGION_MASTER_ROUTE: string = join(REGION_ROUTE, "region-master");

export const WARD_ROUTE: string = ROOT_ROUTE ? ROOT_ROUTE + "/ward" : "/ward";
export const WARD_MASTER_ROUTE: string = join(WARD_ROUTE, "ward-master");
export const NATION_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/nation"
  : "/nation";
export const NATION_MASTER_ROUTE: string = join(NATION_ROUTE, "nation-master");

export const USER_MANUAL_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/user-manual-management/user-manual"
  : "/user-manual-management/user-manual";
export const USER_MANUAL_MASTER_ROUTE: string = join(
  USER_MANUAL_ROUTE,
  "user-manual-master"
);

//Workflow
export const WORKFLOW_DEFINITION_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/workflow-definition"
  : "/workflow-definition";
export const WORKFLOW_DEFINITION_MASTER_ROUTE: string = join(
  WORKFLOW_DEFINITION_ROUTE,
  "workflow-definition-master"
);
export const WORKFLOW_DEFINITION_PREVIEW_ROUTE: string = join(
  WORKFLOW_DEFINITION_ROUTE,
  "workflow-definition-preview"
);
export const WORKFLOW_DEFINITION_DETAIL_ROUTE: string = join(
  WORKFLOW_DEFINITION_ROUTE,
  "workflow-definition-detail"
);

export const WORKFLOW_DIRECTION_CONDITION_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/workflow-direction-condition"
  : "/workflow-direction-condition";
export const WORKFLOW_DIRECTION_CONDITION_MASTER_ROUTE: string = join(
  WORKFLOW_DIRECTION_CONDITION_ROUTE,
  "workflow-direction-condition-master"
);

export const WORKFLOW_DIRECTION_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/workflow-direction"
  : "/workflow-direction";
export const WORKFLOW_DIRECTION_MASTER_ROUTE: string = join(
  WORKFLOW_DIRECTION_ROUTE,
  "workflow-direction-master"
);
export const WORKFLOW_DIRECTION_DETAIL_ROUTE: string = join(
  WORKFLOW_DIRECTION_ROUTE,
  "workflow-direction-detail"
);
export const WORKFLOW_DIRECTION_PREVIEW_ROUTE: string = join(
  WORKFLOW_DIRECTION_ROUTE,
  "workflow-direction-preview"
);
export const WORKFLOW_OPERATOR_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/workflow-operator"
  : "/workflow-operator";
export const WORKFLOW_OPERATOR_MASTER_ROUTE: string = join(
  WORKFLOW_OPERATOR_ROUTE,
  "workflow-operator-master"
);

export const WORKFLOW_PARAMETER_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/workflow-parameter"
  : "/workflow-parameter";
export const WORKFLOW_PARAMETER_MASTER_ROUTE: string = join(
  WORKFLOW_PARAMETER_ROUTE,
  "workflow-parameter-master"
);

export const WORKFLOW_PARAMETER_TYPE_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/workflow-parameter-type"
  : "/workflow-parameter-type";
export const WORKFLOW_PARAMETER_TYPE_MASTER_ROUTE: string = join(
  WORKFLOW_PARAMETER_TYPE_ROUTE,
  "workflow-parameter-type-master"
);

export const WORKFLOW_STATE_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/workflow-state"
  : "/workflow-state";
export const WORKFLOW_STATE_MASTER_ROUTE: string = join(
  WORKFLOW_STATE_ROUTE,
  "workflow-state-master"
);

export const WORKFLOW_STEP_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/workflow-step"
  : "/workflow-step";
export const WORKFLOW_STEP_MASTER_ROUTE: string = join(
  WORKFLOW_STEP_ROUTE,
  "workflow-step-master"
);
export const WORKFLOW_STEP_DETAIL_ROUTE: string = join(
  WORKFLOW_STEP_ROUTE,
  "workflow-step-detail"
);

export const WORKFLOW_TYPE_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/workflow-type"
  : "/workflow-type";
export const WORKFLOW_TYPE_MASTER_ROUTE: string = join(
  WORKFLOW_TYPE_ROUTE,
  "workflow-type-master"
);

export const LDAP_CONFIGURATION_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/ldap-configuration"
  : "/ldap-configuration";

export const INIT_ROUTE: string = ROOT_ROUTE ? ROOT_ROUTE + "/init" : "/init";
export const INIT_MASTER_ROUTE: string = join(INIT_ROUTE, "init-master");

export const CONFIGURATION_MANAGEMENT_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/configuration-management"
  : "/configuration-management";

// Cấu hình đăng nhập

export const LOGIN_CONFIGURATION_ROUTE: string = join(
  CONFIGURATION_MANAGEMENT_ROUTE,
  "login-configuration"
);

export const LOGIN_CONFIGURATION_MASTER_ROUTE: string = join(
  LOGIN_CONFIGURATION_ROUTE,
  "login-configuration-master"
);
export const LOGIN_CONFIGURATION_DETAIL_ROUTE: string = join(
  LOGIN_CONFIGURATION_ROUTE,
  "login-configuration-detail"
);
// Phân hệ

export const SITE_ROUTE: string = join(CONFIGURATION_MANAGEMENT_ROUTE, "site");
export const SITE_MASTER_ROUTE: string = join(SITE_ROUTE, "site-master");

export const MENU_REPORT_ROUTE: string = join(
  CONFIGURATION_MANAGEMENT_ROUTE,
  "menu-report"
);

// Tệp mẫu

export const MENU_REPORT_MASTER_ROUTE: string = join(
  MENU_REPORT_ROUTE,
  "menu-report-master"
);
export const MENU_REPORT_DETAIL_ROUTE: string = join(
  MENU_REPORT_ROUTE,
  "menu-report-detail"
);
export const MENU_REPORT_PREVIEW_ROUTE: string = join(
  MENU_REPORT_ROUTE,
  "menu-report-preview"
);

export const MENU_REPORT_HISTORY_ROUTE: string = join(
  MENU_REPORT_ROUTE,
  "menu-report-history"
);
export const MENU_REPORT_HISTORY_LIST_ROUTE: string = join(
  MENU_REPORT_HISTORY_ROUTE,
  "menu-report-history-list"
);
export const MENU_REPORT_HISTORY_DETAIL_ROUTE: string = join(
  MENU_REPORT_HISTORY_ROUTE,
  "menu-report-history-detail"
);
export const MENU_REPORT_HISTORY_PREVIEW_ROUTE: string = join(
  MENU_REPORT_HISTORY_ROUTE,
  "menu-report-history-preview"
);

// cấu hình email
export const CONFIGURATION_ASSET_MANAGEMENT_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/asset-management"
  : "/asset-management";

export const EMAIL_REMINDER_CONFIG_ROUTE: string = join(
  CONFIGURATION_ASSET_MANAGEMENT_ROUTE,
  "email-reminder-config"
);
export const EMAIL_REMINDER_CONFIG_MASTER_ROUTE: string = join(
  EMAIL_REMINDER_CONFIG_ROUTE,
  "email-reminder-config-master"
);
export const EMAIL_REMINDER_CONFIG_DETAIL_ROUTE: string = join(
  EMAIL_REMINDER_CONFIG_ROUTE,
  "email-reminder-config-detail"
);
export const EMAIL_REMINDER_CONFIG_PREVIEW_ROUTE: string = join(
  EMAIL_REMINDER_CONFIG_ROUTE,
  "email-reminder-config-preview"
);

export const FILE_TEMPLATE_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/file-template"
  : "/file-template";
export const FILE_TEMPLATE_MASTER_ROUTE: string = join(
  FILE_TEMPLATE_ROUTE,
  "file-template-master"
);
export const FILE_TEMPLATE_DETAIL_ROUTE: string = join(
  FILE_TEMPLATE_ROUTE,
  "file-template-detail"
);
export const FILE_TEMPLATE_PREVIEW_ROUTE: string = join(
  FILE_TEMPLATE_ROUTE,
  "file-template-preview"
);

export const POSITION_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/position"
  : "/position";

export const POSITION_MASTER_ROUTE: string = POSITION_ROUTE
  ? POSITION_ROUTE + "/position-master"
  : "/position-master";
export const LOGIN_SSO_WAITING_PAGE: string = "/login-sso-waiting-page";

// Cấu hình phê duyệt

export const INTEGRATION_EAP_CONFIGURATION_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/account/menu"
  : "/account/menu";

export const INTEGRATION_EAP_CONFIGURATION_MASTER_ROUTE: string = join(
  INTEGRATION_EAP_CONFIGURATION_ROUTE,
  "/menu-master"
);

// Báo cáo phân quyền

export const PROJECT_AUTHORIZATION_REPORT_ROUTE: string = ROOT_ROUTE
  ? ROOT_ROUTE + "/project-authorization-report"
  : "/project-authorization-report";

export const PROJECT_AUTHORIZATION_REPORT_PREVIEW_ROUTE: string = join(
  PROJECT_AUTHORIZATION_REPORT_ROUTE,
  "/preview"
);
